import type React from 'react';

interface ExitProps {
  size?: number;
  fill?: string;
  className?: string;
}

const Exit: React.FC<ExitProps> = ({ size = 18, fill = '#000000', className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M13.8 3.95972C15.5895 3.95972 17.0403 5.41055 17.0403 7.19995V10.5199C17.0403 10.9838 16.664 11.3601 16.2 11.3601C15.7361 11.3601 15.3598 10.9838 15.3598 10.5199V7.19995C15.3598 6.33839 14.6616 5.64019 13.8 5.64019H7.80005C6.93848 5.64019 6.24028 6.33839 6.24028 7.19995V18C6.24028 18.8615 6.93848 19.5597 7.80005 19.5597H13.8C14.6616 19.5597 15.3598 18.8615 15.3598 18V15.7195C15.3601 15.2558 15.7363 14.8804 16.2 14.8804C16.6638 14.8804 17.04 15.2558 17.0403 15.7195V18C17.0403 19.7894 15.5895 21.2402 13.8 21.2402H7.80005C6.01065 21.2402 4.55981 19.7894 4.55981 18V7.19995C4.55981 5.41055 6.01065 3.95972 7.80005 3.95972H13.8Z"
        fill={fill}
      />
      <path
        d="M18.5088 8.90894C18.7899 8.62781 19.2462 8.62792 19.5273 8.90894L22.752 12.1335C22.78 12.1616 22.8027 12.1932 22.8252 12.2244C22.8587 12.2479 22.8919 12.2735 22.9219 12.3035C23.2027 12.5846 23.2027 13.0399 22.9219 13.321L19.6973 16.5457C19.4161 16.8268 18.9599 16.8268 18.6787 16.5457C18.3978 16.2645 18.3976 15.8082 18.6787 15.5271L20.7666 13.4402H10.3203C9.92282 13.4402 9.59985 13.1179 9.59961 12.7205C9.59961 12.3228 9.92267 11.9998 10.3203 11.9998H20.5811L18.5088 9.92749C18.2278 9.64634 18.2278 9.19007 18.5088 8.90894Z"
        fill={fill}
      />
    </svg>
  );
};

export default Exit;
